import { useField } from "formik";

const CheckBox = ({ ...props }) => {
	const [field] = useField({ ...props, type: "checkbox" });

	return (
		<div className="auth__form-check">
			<input
				type="checkbox"
				{...field}
				{...props}
			/>
			<label htmlFor={props.id || props.name}>{props.text}</label>
		</div>
	);
};

export default CheckBox;
